import { render } from "./PdfWrapper.vue?vue&type=template&id=ba031660&scoped=true"
import script from "./PdfWrapper.vue?vue&type=script&lang=js"
export * from "./PdfWrapper.vue?vue&type=script&lang=js"

import "./PdfWrapper.vue?vue&type=style&index=0&id=ba031660&scoped=true&lang=scss"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba031660"]])

export default __exports__